import { gql } from "@apollo/client"
import craftApolloClient from "../api/apollo"

import { useContext } from "react"
import { GlobalContext } from '../_app'

import parse from 'html-react-parser'

import Image from "next/image"

import { 
    QuerySEO,
	QueryPartners
} from "../../graphql/queries"

import { Header, HeaderShim } from '../../fuselage/global/header/header'
import { Footer } from '../../fuselage/theme/2024/layout/footer/footer'
import { OffsiteLink } from '../../fuselage/components/offsite-link/offsite-link'
import { StickySidebar } from '../../fuselage/layout/sticky-sidebar/sticky-sidebar'
import { ArrowLink } from '../../fuselage/components/arrow-link/arrow-link'
import { ButtonSocial } from  '../../fuselage/components/button-social/button-social'

import CSS from '../../css/app/partners.module.css'

function Partner({ partner }) {

	const globals = useContext(GlobalContext)

	// console.log('partner data:', partner)

	const handleLinkedIn = () => {
		if ( partner.linkedin ) {
			return (
				<>
					<ButtonSocial 
						icon='linkedin' 
						url={partner.linkedin} 
						alt='linkedin'
						target='_blank'
						rel='noreferrer'
						decal={'bg-secondary'}
					/>&ensp;
				</>
			)
		}
	}
	const handleTwitter = () => {
		if ( partner.twitter ) {
			return (
				<>
					<ButtonSocial 
						icon='twitter' 
						url={`https://www.twitter.com/${partner.twitter}`} 
						alt='twitter'
						target='_blank'
						rel='noreferrer'
						decal={'bg-secondary'}
					/>&ensp;
				</>
			)
		}
	}
	const handleFacebook = () => {
		if ( partner.facebook ) {
			return (
				<ButtonSocial 
					icon='facebook' 
					url={partner.facebook} 
					alt='twitter'
					target='_blank'
					rel='noreferrer'
					decal={'bg-secondary'}
				/>
			)
		}
	}
	const handleWebsite = () => {
		if( partner.website ) {
			return (
				<OffsiteLink href={partner.website} direction='right' target='_blank'>
					Learn more
				</OffsiteLink>
			)
		}
	}

	return (

		<>
			<Header mainMenu={globals.nodes} />

			<section className="block pt-0">
				<div className="container">

					<StickySidebar size='medium'>

						<aside className="formatted">
							<HeaderShim/>
							<p className="fw-600"><ArrowLink href="/partners">View all partners</ArrowLink></p>

							<div className="bg-white p-sm mt-sm center">
								{
									partner.partnerLogo ?
										<div className={CSS.logo}>
											<Image 
												src={partner.partnerLogo[0].url} 
												width={500}
												height={400}
												layout='responsive'
												alt=""
												unoptimized
											/>
										</div>
									: null
										
								}
							</div>

							<div className="mt-sm">
								{ handleLinkedIn() }
								{ handleTwitter() }
								{ handleFacebook() }
							</div>
							
						</aside>
						
						<main className="maxw-60">
							<HeaderShim/>
							{
								partner.level &&
								<p className='fs-5 fw-600 lh-1 c-primary maxw-40'>{GetBizzaboPartnerLevelTitle(partner.level)}</p>

							}
							<p className="fs-3 fw-600 caps mt-sm">{partner.title}</p>
							{
								partner.partnerProfile &&
								<p className="mt-sm maxw-50" style={{ whiteSpace: `pre-line` }}>{parse(String(partner.partnerProfile)) }</p>
							}
							<p className="mt-md fw-600">{ handleWebsite() }</p>
						</main>

					</StickySidebar>

				</div>
			</section>

			<Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>
		</>
	)
}
Partner.theme = 'aviadev-2024'






export async function getStaticPaths() {

	const cmsData = await craftApolloClient().query({
        query: gql`
			query Entries {
				entries(site: "${process.env.SITE_HANDLE}", section: "partners") {
					... on partners_partner_Entry {
						id
						slug
					}
				}
			}
        `
    })

	return {
		// paths: cmsData.data.entries.map( entry => ({ params: { slug: entry.slug } })),
		// fallback: false
		paths: [],
		fallback: 'blocking',
	}
}

export async function getStaticProps({ params }) {

	// console.log('params',params)
	
	const partner = await craftApolloClient().query({
        query: gql`
			query Page {
				entry(site: "${process.env.SITE_HANDLE}", slug: "${params.slug}" ) {
					... on partners_partner_Entry {
						id
						slug
						title
						website
						partnerProfile
						partnerLogo {
							id
							url
							width
							height
						}
					}
				}
			}
        `
    })

	return {
		props: { 
			partner: partner.data.entry 
		}
	}
}





export default Partner


